import * as v from "valibot";

import { rpcContract } from "../rpc";

export const profileColorsRpcContract = rpcContract({
  name: "profileColors",
  paramsSchema: v.undefined(),
  resultSchema: v.object({
    colors: v.array(
      v.object({
        primary: v.string(),
        secondary: v.string(),
      }),
    ),
  }),
});

export type ProfileColorsParams = v.InferOutput<(typeof profileColorsRpcContract)["paramsSchema"]>;

export type ProfileColorsResult = v.InferOutput<(typeof profileColorsRpcContract)["resultSchema"]>;
